<template>
    <div>
        <b-button @click="connect">Connect</b-button>
        <b-button @click="launch">Launch</b-button>
        <b-button @click="disconnect">Disconnect</b-button>
    </div>
</template>

<script>
    export default {
        name: 'VueQzTrayControl',
        data() {
            return {
            };
        },
        methods: {
            launch() {
                this.$qz.launch();
            },
            connect() {
                this.$qz.connect();
            },
            disconnect() {
                this.$qz.disconnect();
            }
        }
    };
</script>

<style scoped>

</style>
